module.exports = __webpack_public_path__ + "img/logo.194a64de.png";